import Chart from 'chart.js/auto';
import def_day_lines, { xAxisConfig, tooltipCallbacks, enableTouchPan } from './graph_utils.js';

export default function graph_fumee(ser, times, ff){

  var pm_col = new Array(ff.length);
  var pm_sfc = new Array(ff.length);
  for(let i=0; i < ff.length; i++){
    pm_col[i]=ff[i][0]*1.e6;
    pm_sfc[i]=ff[i][1]*1.e9;
  }
  const dt = {
    datasets: [
      {
	label: 'Fumée de feux de forêt (masse de PM 2.5 en mg/m² dans la colonne atmosphérique)',
	data: times.map((t, i) => ({ x: t.getTime(), y: pm_col[i] })),
	fill: false,
	borderColor: 'rgb(58, 115, 214)',
	lineTension: 0.3,
	yAxisID: 'y'
      },
      {
	label: 'Fumée de feux de forêt (concentration de PM 2.5 en surface en μg/m³)',
	data: times.map((t, i) => ({ x: t.getTime(), y: pm_sfc[i] })),
	fill: false,
	borderColor: 'rgb(58, 214, 115)',
	lineTension: 0.3,
	yAxisID: 'y1'
      }
    ]
  };
  var ann = [];
  def_day_lines(times, ann);

  const ctx = document.getElementById('id_series_canvas');
  if(ser.chart){
    ser.chart.destroy();
  }
  ser.chart = new Chart(ctx, {
    type: 'line',
    data: dt,
    options: {
      maintainAspectRatio: false,
      animations: false,
      responsive: true,
      scales: {
	x: xAxisConfig(times),
	y: {
	  title: {
	    display: true,
	    text: 'PM 2.5 dans la colonne atmosphérique [mg/m²]'
	  },
	  type: 'logarithmic',
	  suggestedMax: 50
	},
	y1: {
	  title: {
	    display: true,
	    text: 'PM 2.5 en surface [μg/m³]'
	  },
          type: 'logarithmic',
	  suggestedMax: 100,
          display: true,
          position: 'right',
          grid: {
            drawOnChartArea: false,
          }
	}
      },
      plugins: {
	tooltip: { callbacks: tooltipCallbacks },
	annotation: {
	  adjustScaleRange: false,
	  annotations: ann
	},
	zoom: {
	  zoom: {
	    wheel: { enabled: true },
	    pinch: { enabled: true },
	    mode: "x",
	    speed: 100
	  },
	  pan: {
	    enabled: true,
	    mode: "x",
	    speed: 100
	  }
	}
      }
    }
  });
  enableTouchPan(ser.chart);
}
